import { render, staticRenderFns } from "./CloseIconButton.vue?vue&type=template&id=11aaf400&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CloseIconButton.vue"
export default component.exports